import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=4c7000fc&scoped=true&"
import script from "./Hotels.vue?vue&type=script&lang=js&"
export * from "./Hotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7000fc",
  null
  
)

export default component.exports